exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.th_useCase[data-v-039c5b43] {\r\n  background: darkgray;\r\n  width: 25%;\n}\n.th_source[data-v-039c5b43] {\r\n  background: rgb(79, 129, 189);\r\n  width: 25%;\n}\n.th_mapping[data-v-039c5b43] {\r\n  background: rgb(255, 235, 156);\r\n  color: rgb(156, 101, 0);\r\n  width: 25%;\n}\n.th_target[data-v-039c5b43] {\r\n  background: rgb(192, 80, 77);\r\n  width: 25%;\n}\n.ul_checkList[data-v-039c5b43] {\r\n  list-style-type: none;\r\n  padding: 0;\r\n  margin: 0;\n}\r\n", ""]);

// exports
